import $http from "@/http/index";

//获取汽车利率
export const getCarApr = (data) => {
  return $http.get("/open/getCarApr", data)
}

//获取所有的服务品牌
export const getBrandList = (data) => {
  return $http.get("/api/brand/brandList", data)
}

//获取品牌车型列表
export const getModelList = (data) => {
  return $http.get(`/financial/modelList/${data.brandId}`, data)
}

//获取品牌车型版本列表
export const getFinancialVersionList = (data) => {
  return $http.get(`/financial/versionList`, {
    params: data
  })
}
